module.exports = __webpack_public_path__ + "img/10diamonds.40d735aa.jpg";